import { render } from "./faq-table.vue?vue&type=template&id=355d0493"
import script from "./faq-table.vue?vue&type=script&lang=js"
export * from "./faq-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__